"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuarantorList = void 0;
const complex_data_1 = require("complex-data");
const overdue_1 = __importDefault(require("@/pages/index/api/overdue"));
const location_1 = require("@/pages/index/select/location");
const config_1 = require("@/config/dictionary/config");
const dictionary_1 = require("@/config/dictionary");
const dict_1 = require("@/pages/index/select/dict");
const vue_1 = require("vue");
const overdue_2 = require("@/pages/index/select/overdue");
const complex_utils_1 = require("complex-utils");
const file_1 = require("@/pages/index/utils/file");
const complex_plugin_1 = require("complex-plugin");
const contractLock_1 = __importDefault(require("@/pages/index/api/contractLock"));
const utils_1 = require("@/config/utils");
const layout_1 = __importDefault(require("@/config/utils/layout"));
const config_2 = __importDefault(require("@/config"));
/**
 * 担保人列表
 * 1.已提交完成的记录可以查看并添加附件，其他状态不允许添加附件
 * 2.开始签约后不允许修改信息
*/
class GuarantorList extends complex_data_1.ComplexList {
    buildItem(postData, overdueRecordId) {
        return new Promise((resolve, reject) => {
            if (postData.signMethod === 'QI_YUE_SUO') {
                postData.guarantorStatus = 'DRAFT';
            }
            else {
                postData.guarantorStatus = 'SUBMITTED';
            }
            postData.overdueRecordId = overdueRecordId;
            overdue_1.default.overdueGuarantorBuildOrChange.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('追加担保人新增成功！', 'success');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    changeItem(postData, overdueRecordId, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            overdue_1.default.overdueGuarantorBuildOrChange.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('追加担保人修改成功！', 'success');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    saveAttachment(postData, overdueRecordId, originData) {
        return new Promise((resolve, reject) => {
            (0, file_1.saveFile)(originData.id, 'guarantorAttachment', postData.attachmentList).then(() => {
                complex_plugin_1.notice.showMsg('追加担保人文件上传成功！', 'success');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    refreshContractLock(id) {
        return new Promise((resolve, reject) => {
            contractLock_1.default.refresh.require({
                guarantorId: id
            }).then(() => {
                this.$reloadData(true).finally(() => {
                    complex_plugin_1.notice.showMsg('契约锁状态拉取成功！', 'success');
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    pushContractLockCredit(id) {
        return new Promise((resolve, reject) => {
            contractLock_1.default.pushCredit.require({
                guarantorId: id
            }).then(() => {
                this.$reloadData(true).finally(() => {
                    complex_plugin_1.notice.showMsg('征信授权书发送成功！', 'success');
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    pushContractLockCommitment(id) {
        return new Promise((resolve, reject) => {
            contractLock_1.default.pushCommitment.require({
                guarantorId: id
            }).then(() => {
                this.$reloadData(true).finally(() => {
                    complex_plugin_1.notice.showMsg('担保承诺函发送成功！', 'success');
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.GuarantorList = GuarantorList;
const layoutParse = new layout_1.default(3, 9, 15);
const guarantorList = new GuarantorList({
    name: '担保人列表',
    prop: 'guarantorList',
    module: {
        pagination: true,
        // choice: {},
        search: {
            module: {
                dictionary: {
                    layout: {
                        default: {
                            grid: 8,
                            label: 8,
                            content: 16
                        }
                    },
                    list: [
                        {
                            prop: 'contractNumber',
                            name: '合同号',
                            originProp: 'contractNumber',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                        {
                            prop: 'customerName',
                            name: '承租人',
                            originProp: 'customerName',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                        {
                            prop: 'contactName',
                            name: '担保人',
                            originProp: 'contactName',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                    ]
                }
            },
            menu: {
                list: []
            },
        },
        dictionary: {
            layout: {
                default: layoutParse.getData(3)
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'menu',
                    name: '操作',
                    originProp: 'menu',
                    originFrom: 'local',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(2)
                        }
                    }
                },
                {
                    prop: 'id',
                    name: 'ID',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'contractId',
                    name: '合同ID',
                    originProp: 'contractId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'overdueRecordId',
                    name: '逾期记录ID',
                    originProp: 'overdueRecordId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'contractNumber',
                    name: '合同号',
                    originProp: 'contractNumber',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.contractNumber
                        }
                    }
                },
                {
                    prop: 'customerName',
                    name: '承租人',
                    originProp: 'customerName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.WAY_OF_SIGNING, {
                    prop: 'signMethod',
                    name: '签约方式',
                    originProp: 'signMethod',
                    originFrom: 'list',
                    mod: {
                        list: {},
                        edit: {
                            required: true,
                            disabled: {
                                default: false,
                                change: true
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.GuaranteeType, {
                    prop: 'guarantorType',
                    name: '担保类型',
                    originProp: 'guarantorType',
                    originFrom: 'list',
                    mod: {
                        list: {},
                        edit: {
                            required: true,
                            observe(target, prop, val, from) {
                                if (from === 'init' && target.$type === 'build') {
                                    // 新增初始化时
                                    const value = this.$option.list[0].value;
                                    target.$data.guarantorType = value;
                                }
                            },
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.family_relative_guarantee, {
                    prop: 'relateType',
                    name: '关系',
                    originProp: 'relateType',
                    originFrom: 'list',
                    mod: {
                        list: {},
                        edit: {
                            required: true
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                }),
                {
                    prop: 'contactName',
                    name: '担保人姓名',
                    originProp: 'contactName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        },
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 40
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'idCard',
                    name: '证件号码',
                    originProp: 'idCard',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.identityCard
                        },
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 18
                            },
                            rules: [
                                {
                                    validator(rule, val) {
                                        if (val) {
                                            if (utils_1.RegExpRule.identityCard.test(val) || utils_1.RegExpRule.unifiedSocialCreditCode.test(val)) {
                                                return Promise.resolve();
                                            }
                                            else {
                                                return Promise.reject();
                                            }
                                        }
                                        return Promise.reject();
                                    },
                                    message: '请输入正确的证件号码'
                                }
                            ],
                            // observe(this: DefaultEdit<'input'>, target, prop, val, from) {
                            //   const dateOfBirth = target.getItem('dateOfBirth')!
                            //   if (from !== 'init' && prop === this.prop) {
                            //     // 非加载模式下证件号变更
                            //     const code = val as string
                            //     if (code && code.length === 18) {
                            //       if (RegExpRule.identityCard.test(val)) {
                            //       }
                            //     }
                            //   } else {
                            //     dateOfBirth.disabled.setData('default', false)
                            //   }
                            // },
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'contactPhone',
                    name: '手机号码',
                    originProp: 'contactPhone',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.phone
                        },
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 40
                            },
                            rules: [
                                {
                                    validator(rule, val) {
                                        if (val) {
                                            if (utils_1.RegExpRule.mobilePhone.test(val)) {
                                                return Promise.resolve();
                                            }
                                            else {
                                                return Promise.reject();
                                            }
                                        }
                                        return Promise.reject();
                                    },
                                    message: '请输入正确的手机号码'
                                }
                            ]
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.marry, {
                    prop: 'marryType',
                    name: '婚姻状态',
                    originProp: 'marryType',
                    originFrom: 'list',
                    mod: {
                        list: {},
                        edit: {
                            required: true
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.BONDSMAN_STATUS, {
                    prop: 'guarantorStatus',
                    name: '状态',
                    originProp: 'guarantorStatus',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(overdue_2.contractLockContractStatus, {
                    prop: 'creditAuthStatus',
                    name: '征信授权书状态',
                    originProp: 'creditAuthStatus',
                    originFrom: 'list',
                    mod: {}
                }),
                {
                    prop: 'creditAccreditUrl',
                    name: '征信授权书',
                    originProp: 'creditAccreditUrl',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(8),
                            render({ record }) {
                                // 0 {value: 'QI_YUE_SUO', label: '契约锁'} {value: 'OFFLINE', label: '线下'}
                                // dict.BONDSMAN_STATUS {value: "DRAFT", label: "草稿"} {value: "SUBMITTED", label: "已提交"} {value: "AUDIT_SUCCEED", label: "审核通过"} {value: "AUDIT_ERROR", label: "审核失败"} {value: "SUCCEED", label: "完成"} {value: "CONTRACT_EXPIRED", label: "合同截止签署"} {value: "CONTRACT_REJECTED", label: "合同签署已退回"} {value: "CONTRACT_ERROR", label: "合同异常"}
                                if (record.signMethod.value === 'QI_YUE_SUO') {
                                    const content = [];
                                    const module = {
                                        status: true,
                                        show: !!record.creditAccreditUrl,
                                        push: false,
                                        refresh: false
                                    };
                                    if (record.creditAuthStatus.status >= 20) {
                                        module.status = false;
                                    }
                                    if (record.guarantorStatus.value === 'DRAFT') {
                                        if (record.creditAuthStatus.status === 20) {
                                            module.push = true;
                                        }
                                        else if (record.creditAuthStatus.status === 30) {
                                            module.refresh = true;
                                        }
                                    }
                                    if (module.status) {
                                        content.push((0, vue_1.h)('span', {
                                            style: {
                                                color: record.creditAuthStatus.color
                                            }
                                        }, record.creditAuthStatus.label));
                                    }
                                    if (module.show) {
                                        content.push((0, vue_1.h)('span', {
                                            onClick() {
                                                (0, complex_utils_1.openWindow)(record.creditAccreditUrl);
                                            }
                                        }, '查看'));
                                    }
                                    if (module.push) {
                                        content.push((0, vue_1.h)('span', {
                                            onClick() {
                                                guarantorList.$triggerMethod('pushContractLockCredit', [record.id], true);
                                            }
                                        }, '发送'));
                                    }
                                    if (module.refresh) {
                                        content.push((0, vue_1.h)('span', {
                                            onClick() {
                                                guarantorList.$triggerMethod('refreshContractLock', [record.id], true);
                                            }
                                        }, '拉取'));
                                    }
                                    return (0, vue_1.h)('div', {
                                        class: 'local-main-table-menu-list'
                                    }, content);
                                }
                            },
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(overdue_2.contractLockContractStatus, {
                    prop: 'commitmentStatus',
                    name: '担保承诺函状态',
                    originProp: 'commitmentStatus',
                    originFrom: 'list',
                    mod: {}
                }),
                {
                    prop: 'commitmentUrl',
                    name: '担保承诺函',
                    originProp: 'commitmentUrl',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(8),
                            render({ record }) {
                                if (record.signMethod.value === 'QI_YUE_SUO') {
                                    const content = [];
                                    const module = {
                                        status: true,
                                        show: !!record.commitmentUrl,
                                        push: false,
                                        refresh: false
                                    };
                                    if (record.commitmentStatus.status >= 20) {
                                        module.status = false;
                                    }
                                    if (record.guarantorStatus.value === 'AUDIT_SUCCEED') {
                                        if (record.commitmentStatus.status === 20) {
                                            module.push = true;
                                        }
                                        else if (record.commitmentStatus.status === 30) {
                                            module.refresh = true;
                                        }
                                    }
                                    if (module.status) {
                                        content.push((0, vue_1.h)('span', {
                                            style: {
                                                color: record.creditAuthStatus.color
                                            }
                                        }, record.commitmentStatus.label));
                                    }
                                    if (module.show) {
                                        content.push((0, vue_1.h)('span', {
                                            onClick() {
                                                (0, complex_utils_1.openWindow)(record.commitmentUrl);
                                            }
                                        }, '查看'));
                                    }
                                    if (module.push) {
                                        content.push((0, vue_1.h)('span', {
                                            onClick() {
                                                guarantorList.$triggerMethod('pushContractLockCommitment', [record.id], true);
                                            }
                                        }, '发送'));
                                    }
                                    if (module.refresh) {
                                        content.push((0, vue_1.h)('span', {
                                            onClick() {
                                                guarantorList.$triggerMethod('refreshContractLock', [record.id], true);
                                            }
                                        }, '拉取'));
                                    }
                                    return (0, vue_1.h)('div', {
                                        class: 'local-main-table-menu-list'
                                    }, content);
                                }
                            },
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.sex, {
                    prop: 'sex',
                    name: '性别',
                    originProp: 'sex',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            required: true
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                }),
                {
                    prop: 'dateOfBirth',
                    name: '出生日期',
                    originProp: 'dateOfBirth',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'date',
                            required: true
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'workCompanyName',
                    name: '单位名称',
                    originProp: 'workCompanyName',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                size: 100
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'workCompanyAddress',
                    name: '单位地址',
                    originProp: 'workCompanyAddress',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                size: 100
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'workMonthlyIncome',
                    name: '月收入',
                    originProp: 'workMonthlyIncome',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'inputNumber',
                            required: true,
                            option: {
                                min: 0
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'workCompanyMobile',
                    name: '单位电话',
                    originProp: 'workCompanyMobile',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 40
                            },
                            rules: [
                                {
                                    validator(rule, val) {
                                        if (val) {
                                            if (utils_1.RegExpRule.mobilePhone.test(val) || utils_1.RegExpRule.linePhone.test(val)) {
                                                return Promise.resolve();
                                            }
                                            else {
                                                return Promise.reject();
                                            }
                                        }
                                        return Promise.reject();
                                    },
                                    message: '请输入正确的联系电话'
                                }
                            ]
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'provinceCode',
                    showProp: {
                        default: 'value',
                        list: 'label'
                    },
                    name: '省市',
                    originProp: 'provinceCode',
                    originFrom: 'list',
                    format(value, { originData }) {
                        const cityCode = originData.cityCode;
                        const provinceValue = location_1.location.getItem(value);
                        const valueList = [value, cityCode];
                        if (cityCode && provinceValue.children) {
                            const cityValue = provinceValue.children.find(item => item.value === cityCode);
                            return {
                                value: valueList,
                                label: cityValue.label
                            };
                        }
                        return {
                            value: valueList,
                            label: provinceValue.label
                        };
                    },
                    post(value, { targetData }) {
                        const [provinceCode, cityCode] = value;
                        targetData.cityCode = cityCode;
                        return provinceCode;
                    },
                    mod: {
                        edit: {
                            type: 'cascader',
                            required: true,
                            option: {
                                list: location_1.location.getList()
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'address',
                    name: '详细地址',
                    originProp: 'address',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'input',
                            required: true,
                            option: {
                                maxLength: 100
                            }
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'remark',
                    name: '备注',
                    originProp: 'remark',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'uploadFileList',
                    name: '文件',
                    originProp: 'uploadFileList',
                    originFrom: 'list',
                    layout: {
                        default: layoutParse.getData(1)
                    },
                    post(value) {
                        return value.map(item => item.data);
                    },
                    mod: {
                        edit: {
                            type: 'file',
                            multiple: true,
                            required: false,
                            disabled: {
                                default: false,
                                change: true
                            },
                            local: {
                                target: {
                                    props: {
                                        complex: true
                                    }
                                }
                            },
                            option: {
                                accept: config_2.default.file,
                                upload(fileList) {
                                    return (0, file_1.uploadFile)(fileList, 'guarantorFile');
                                }
                            },
                            observe(target, prop, val) {
                                if (prop === 'signMethod') {
                                    if (val === 'OFFLINE') {
                                        target.show('uploadFileList');
                                    }
                                    else {
                                        target.hidden('uploadFileList');
                                    }
                                }
                            },
                        },
                        build: {
                            $target: 'edit'
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'attachmentList',
                    name: '附件',
                    originProp: 'attachmentList',
                    originFrom: 'list',
                    layout: {
                        default: layoutParse.getData(1)
                    },
                    post(value) {
                        return value.map(item => item.data);
                    },
                    mod: {
                        edit: {
                            type: 'file',
                            multiple: true,
                            required: false,
                            local: {
                                target: {
                                    props: {
                                        complex: true
                                    }
                                }
                            },
                            option: {
                                accept: config_2.default.file,
                                upload(fileList) {
                                    return (0, file_1.uploadFile)(fileList, 'guarantorAttachment');
                                }
                            }
                        },
                        change: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'createdBy',
                    name: '添加人',
                    originProp: 'createdBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdTime',
                    name: '添加时间',
                    originProp: 'createdTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'updatedBy',
                    name: '修改人',
                    originProp: 'updatedBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedTime',
                    name: '修改时间',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
            ]
        }
    },
    $getData() {
        return new Promise((resolve, reject) => {
            const parentId = this.$getExtra('parentId');
            const postData = !parentId ? Object.assign(Object.assign({}, this.$getSearch()), { pageNo: this.$getPageData('current'), pageSize: this.$getPageData('size') }) : {
                contractId: parentId,
                pageNo: 1,
                pageSize: 10000
            };
            overdue_1.default.overdueGuarantorList.require(postData).then(res => {
                this.$formatList(res.data.data, res.data.totalCount);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
exports.default = guarantorList;
